export default __webpack_public_path__ + "static/media/smallcase.ba69d282.svg";